import { gql } from '@apollo/client'

export const PROJECT_REPORT_QUERY = gql`
  query projectReport($filter: ProjectReportFilter!) {
    projectReport(filter: $filter) {
      project {
        id
        title
        insuranceId
        interface
      }
      team {
        id
        title
      }
      mainPeriod {
        legalAdviceCasesTotal
        transferredCasesTotal
        serviceCallCasesTotal
      }
      comparisionPeriod {
        legalAdviceCasesTotal
        transferredCasesTotal
        serviceCallCasesTotal
      }
      trend {
        legalAdviceCasesTotal
        transferredCasesTotal
        serviceCallCasesTotal
      }
    }
  }
`
